export const search_tags = [
    {
        name: "USA",
        type: "country",
        id: 14,
    },
    {
        name: "Australia",
        type: "country",
        id: 6,
    },
    {
        name: "MBA",
        type: "search",
        id: null,
    },
    {
        name: "Switzerland",
        type: "country",
        id: 8,
    },
    {
        name: "Mechanical Engineering",
        type: "search",
        id: null,
    },
    {
        name: "Canada",
        type: "country",
        id: 7,
    },
    {
        name: "UK",
        type: "country",
        id: 4,
    },
    {
        name: "Hospitality",
        type: "search",
        id: null,
    },
    {
        name: "Tourism",
        type: "search",
        id: null,
    },
    {
        name: "Data Science",
        type: "search",
        id: null,
    },
    {
        name: "Artificial Intelligence",
        type: "search",
        id: null,
    },
    {
        name: "Robotics",
        type: "search",
        id: null,
    },
    {
        name: "Ireland",
        type: "country",
        id: 18,
    },
    {
        name: "Entrepreneurship",
        type: "search",
        id: null,
    },
    {
        name: "Project Management",
        type: "search",
        id: null,
    },
    {
        name: "Law",
        type: "search",
        id: null,
    },
];

export const bottom_search_tags = [
    {
        name: "MBA",
        type: "search",
        id: null
    },
    {
        name: "Management",
        type: "search",
        id: null
    },
    {
        name: "Entrepreneurship",
        type: "search",
        id: null
    },
    {
        name: "Sales",
        type: "search",
        id: null
    },
    {
        name: "Marketing",
        type: "search",
        id: null
    },
    {
        name: "Finance",
        type: "search",
        id: null
    },
    {
        name: "Mechanical Engineering",
        type: "search",
        id: null
    },
    {
        name: "Electrical",
        type: "search",
        id: null
    },
    {
        name: "Electronic Engineering",
        type: "search",
        id: null
    },
    {
        name: "Digital Media",
        type: "search",
        id: null
    },
    {
        name: "Project Management",
        type: "search",
        id: null
    },
    {
        name: "Data Science",
        type: "search",
        id: null
    },
    {
        name: "Psychology",
        type: "search",
        id: null
    },
    {
        name: "Computer Science",
        type: "search",
        id: null
    },
    {
        name: "Cyber Security",
        type: "search",
        id: null
    },
    {
        name: "Cloud Computing",
        type: "search",
        id: null
    },
    {
        name: "Hospitality",
        type: "search",
        id: null
    },
    {
        name: "Tourism",
        type: "search",
        id: null
    },
    {
        name: "Culinary",
        type: "search",
        id: null
    },
    {
        name: "Bakery",
        type: "search",
        id: null
    },
    {
        name: "MBBS",
        type: "search",
        id: null
    },
    {
        name: "Artificial Intelligence",
        type: "search",
        id: null
    },
    {
        name: "Robotics",
        type: "search",
        id: null
    },
    {
        name: "Fine Arts",
        type: "search",
        id: null
    },
    {
        name: "Sports Management",
        type: "search",
        id: null
    },
    {
        name: "Law",
        type: "search",
        id: null
    },
    {
        name: "Civil",
        type: "search",
        id: null
    },
    {
        name: "Construction Engineering",
        type: "search",
        id: null
    },
    {
        name: "Interior Design",
        type: "search",
        id: null
    },
    {
        name: "Film",
        type: "search",
        id: null
    },
    {
        name: "Television",
        type: "search",
        id: null
    },
    {
        name: "Information Technology",
        type: "search",
        id: null
    },
    {
        name: "Travel",
        type: "search",
        id: null
    },
    {
        name: "Tourism",
        type: "search",
        id: null
    },
];



// WEBPACK FOOTER //
// ./src/data/homeData.js